
    import "src/app/AppSeller/Insights/index.module.scss?farm_css_modules";
    
    export default {"five": `five-66cea5fa`,"four": `four-66cea5fa`,"gridAreaParentDiv": `gridAreaParentDiv-66cea5fa`,"one": `one-66cea5fa`,"pieChartDiv": `pieChartDiv-66cea5fa`,"six": `six-66cea5fa`,"three": `three-66cea5fa`,"topButton": `topButton-66cea5fa`,"two": `two-66cea5fa`}
    